<template>
    <v-dialog
        v-model="value"
        width="420"
        persistent
    >

        <!-- Custom :title value to delete data gathering dialog -->
        <action-confirmation-card
            :title="deleteDataGathering"
            :confirm-btn-text="confirmBtnText"
            @confirm="confirm"
            @cancel="close"
            :loading="loading"
        >
            {{ $t('data_gatherings.delete_warning',  { data_gathering: dataGatheringInfo.title }) }}
        </action-confirmation-card>
    </v-dialog>
</template>

<script>
import DialogMixin from "@/Shared/Dialogs/DialogMixin";
import ActionConfirmationCard from "@/Shared/ActionConfirmationCard";
import {i18n} from "@/i18n";
import {mapActions} from "pinia";
import {DataGatheringsStore} from "@/Store/DataGatherings/DataGatheringsStore";
import _ from "lodash";
import toastMixin from "@/Shared/toastMixin";

export default {
    name: "DeleteDialog",

    components: {ActionConfirmationCard},

    mixins: [DialogMixin, toastMixin],

    props: {
        dataGathering: {
            type: Object,
            require: true,
        },
    },

    data: () => ({
        deleteDataGathering: i18n.t('data_gatherings.delete_title').toString(),
        confirmBtnText: i18n.t('data_gatherings.delete').toString(),
        loading: false,
    }),

    methods: {
        confirm() {
            this.loading = true;

            this.delete(this.dataGathering)
                .then(data_gathering => {
                    this.$emit('input', false);
                    this.$emit('confirm', data_gathering);

                    this.toast().success(
                        this.$t('data_gatherings.delete_form.success_title', {data_gathering: data_gathering.title}),
                    );
                })
                .catch(error => {
                    this.toast().error(
                        this.$t('data_gatherings.delete_form.error_title'),
                    );

                    console.error('data-gathering.delete.error', error, _.cloneDeep(this.data_gathering));
                })
                .finally(() => this.loading = false);
        },

        ...mapActions(DataGatheringsStore, [
            'delete'
        ]),
    },

    computed: {
        dataGatheringInfo() {
            return {
                title: this.dataGathering.title,
            };
        },
    },
}
</script>

<style scoped>

</style>
